const random16 = () => Math.floor(Math.random() * 1000000).toString(16);

const date16 = () => Date.now().toString(16);

// eslint-disable-next-line import/prefer-default-export
export const uniqueId = () => `${date16()}-${random16()}-${random16()}`;
